import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchAutoResponderFailure,
  fetchAutoResponderSuccess,
} from "../slices/features/autoResponder";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* fetchAutoresponderSaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);
    const response: AxiosResponse<any> = yield call(
      appservice.getAutoresponder,
      baseUrl,
      id
    );
    yield put(fetchAutoResponderSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchAutoResponderFailure({ statusCode, statusText }));
  }
}

export function* watchGetAutoResponder() {
  yield takeLatest(
    RequestTypes.GET_AUTORESPONDER_REQUEST,
    fetchAutoresponderSaga
  );
}
